// Všetky multiselect <select> prvky, ktoré chceme synchronizovať
// (majú data-type, podľa ktorého vieme rozoznať typ filtra)
const propertySelectElements = document.querySelectorAll(
    '.c-filter__selects select.js-dropdown-multiselect[data-type]'
);

// Všetky "vonkajšie" checkboxy, ktoré môžu byť napojené na multiselect
// (len tie, ktoré majú data-type – napr. Len slovenské: data-type="custom_country_of_origin")
const outerPropertyCheckboxes = document.querySelectorAll(
    '.js-property-filter-triggers[data-type]'
);

// Typy (data-type), ktoré sú reálne napojené na nejaký <select>
const syncTypes = new Set(
    [...propertySelectElements].map((select) => select.dataset.type)
);

// ----------------------------------------------------
// SELECT -> VONKAJŠIE CHECKBOXY
// (keď sa zmení select alebo multiselect, nastaví stav vonkajších checkboxov)
// ----------------------------------------------------
export const updateActivePropertyCheckboxes = () => {
    // Mapovanie: data-type => Set(vybraných hodnôt)
    const selectedByType = {};

    propertySelectElements.forEach((select) => {
        const type = select.dataset.type;
        if (!type) return;

        const selectedValues = [...select.selectedOptions].map((opt) => opt.value);
        selectedByType[type] = new Set(selectedValues);
    });

    outerPropertyCheckboxes.forEach((checkbox) => {
        const type = checkbox.dataset.type;
        const value = checkbox.value;

        // Ak nemáme k tomuto typu priradený select, necháme checkbox na pokoji
        if (!syncTypes.has(type)) return;

        const selectedSet = selectedByType[type];
        if (!selectedSet) {
            checkbox.checked = false;
            return;
        }

        checkbox.checked = selectedSet.has(value);
    });
};

// Inicializácia + reakcia na zmenu selectov
updateActivePropertyCheckboxes();
propertySelectElements.forEach((select) => {
    $(select).on('change', updateActivePropertyCheckboxes);
});

// ----------------------------------------------------
// VONKAJŠIE CHECKBOXY -> SELECT + VNÚTORNÝ MULTISELECT
// (keď klikneš na vonkajší checkbox, zmení to aj select a jeho dropdown)
// ----------------------------------------------------
outerPropertyCheckboxes.forEach((checkbox) => {
    const type = checkbox.dataset.type;

    // Synchronizujeme len tie, ktoré majú typ, na ktorý existuje <select>
    if (!syncTypes.has(type)) return;

    checkbox.addEventListener('change', (e) => {
        const cb = e.target;
        const value = cb.value;
        const type = cb.dataset.type;

        // Nájdeme zodpovedajúci <select> podľa data-type
        const relatedSelect = [...propertySelectElements].find(
            (sel) => sel.dataset.type === type
        );
        if (!relatedSelect) return;

        // Nájdeme správnu <option> podľa hodnoty
        const option = [...relatedSelect.options].find(
            (opt) => opt.value === value
        );

        if (option) {
            option.selected = cb.checked;
            // Nech multiselect plugin spraví svoje
            $(relatedSelect).trigger('change');
        }

        // Aktualizujeme aj vykreslený checkbox v multiselect dropdown liste
        const selectWrapper = relatedSelect.closest('.multiselect-native-select');
        if (selectWrapper) {
            const renderedListItems = selectWrapper.querySelectorAll(
                '.multiselect-container li'
            );

            renderedListItems.forEach((li) => {
                const input = li.querySelector('input[type="checkbox"]');
                if (input && input.value === value) {
                    input.checked = cb.checked;
                    li.classList.toggle('active', cb.checked);
                }
            });
        }
    });
});

// ----------------------------------------------------
// BUBBLES -> ZNOVU PREPOČÍTAŤ CHECKBOXY
// (keď sa zruší filter cez bubliny, dorovnáme vonkajšie checkboxy)
// ----------------------------------------------------

// Môžeš mať hore aj dole rôzne kontajnery na bubliny,
// preto berieme oboje: .filter-bubbles aj .c-filter__bubbles
const bubbleFilterContainers = document.querySelectorAll(
    '.filter-bubbles, .c-filter__bubbles'
);

bubbleFilterContainers.forEach((container) => {
    container.addEventListener('click', () => {
        // Počkáme, kým interný JS zmení selecty / hodnoty,
        // a potom dorovnáme vonkajšie checkboxy
        setTimeout(() => {
            updateActivePropertyCheckboxes();
        }, 10);
    });
});
